import { render, staticRenderFns } from "./weekdays.vue?vue&type=template&id=6a37116e&scoped=true&"
import script from "./weekdays.vue?vue&type=script&lang=js&"
export * from "./weekdays.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a37116e",
  null
  
)

export default component.exports